(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  var DURATION = 540;
  var EASING = 'cubic-bezier(.34,1.56,.64,1)';

  function initSection(root) {
    if (!root || root.dataset.adfaqReady === 'true') return;
    root.dataset.adfaqReady = 'true';

    var items = Array.prototype.slice.call(root.querySelectorAll('.adfaq__item'));
    if (!items.length) return;

    var duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : DURATION;

    function clear(panel) {
      panel.style.transition = '';
      panel.style.height = '';
      panel.style.opacity = '';
    }

    function expand(item) {
      var panel = item.querySelector('.adfaq__panel');
      item.open = true;
      item.classList.add('is-open');

      if (!duration) return;

      var target = panel.scrollHeight;
      panel.style.height = '0px';
      panel.style.opacity = '0';

      window.requestAnimationFrame(function () {
        panel.style.transition = 'height ' + duration + 'ms ' + EASING + ', opacity ' + duration + 'ms ' + EASING;
        panel.style.height = target + 'px';
        panel.style.opacity = '1';
      });

      window.setTimeout(function () {
        clear(panel);
      }, duration + 30);
    }

    function collapse(item) {
      var panel = item.querySelector('.adfaq__panel');

      if (!duration) {
        item.classList.remove('is-open');
        item.open = false;
        return;
      }

      panel.style.height = panel.scrollHeight + 'px';
      panel.style.opacity = '1';

      window.requestAnimationFrame(function () {
        panel.style.transition = 'height ' + duration + 'ms ease-out, opacity ' + duration + 'ms ease-out';
        panel.style.height = '0px';
        panel.style.opacity = '0';
      });

      window.setTimeout(function () {
        clear(panel);
        item.classList.remove('is-open');
        item.open = false;
      }, duration + 30);
    }

    items.forEach(function (item) {
      var summary = item.querySelector('.adfaq__sum');
      if (!summary) return;

      summary.addEventListener('click', function (event) {
        event.preventDefault();

        if (item.classList.contains('is-open')) {
          collapse(item);
          summary.setAttribute('aria-expanded', 'false');
          return;
        }

        items.forEach(function (other) {
          if (other !== item && other.classList.contains('is-open')) {
            collapse(other);
            var otherSummary = other.querySelector('.adfaq__sum');
            if (otherSummary) otherSummary.setAttribute('aria-expanded', 'false');
          }
        });

        expand(item);
        summary.setAttribute('aria-expanded', 'true');
      });
    });
  }

  function bootAll() {
    document.querySelectorAll('[data-adfaq]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target.querySelector ? event.target.querySelector('[data-adfaq]') : null;
    if (target) initSection(target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
